import React from 'react';
import Paginations from '../common/paginations';
import constant from '../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const AppliedLeaveList = ({ data, setCurrentPage, limit }) => {
    const { leaves, pagination } = data;
    const { total, page } = pagination;
    console.log(btoa(JSON.stringify(leaves)));
    
    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Employee Name</th>
                            <th>Site Location</th>
                            <th>Leave Type</th>
                            <th>Leave Period</th>
                            <th>Total Days</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {leaves?.length > 0 ? (
                            leaves.map((item, index) => (
                                <React.Fragment>
                                    <tr key={index}>
                                        <td>{(page - 1) * limit + index + 1}</td>
                                        <td>{item.EMPLOYEE_NAME || item.FULL_NAME}</td>
                                        <td>{item.LOCATION_NAME}</td>
                                        <td>{item.LEAVE_TYPE_NAME}</td>
                                        <td><span className='fw-medium'>{item.LEAVE_FROM}</span> to <span className='fw-medium'>{item.LEAVE_TO}</span></td>
                                        <td>{item.TOTAL_DAYS} Days</td>
                                        <td>
                                            <span className={`badge ${item.STATUS === 'APPROVED' ? 'bg-success' : item.STATUS === 'REJECTED' ? 'bg-danger' : 'bg-warning'}`}>
                                                {item.STATUS}
                                            </span>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-20 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href="#"
                                                        title="View Details"
                                                        data-bs-toggle="modal"
                                                        data-bs-target={`#leaveModal-${item.ID}`}
                                                    >
                                                        <i className="bx bxs-zoom-in" />
                                                    </a>
                                                </li>
                                                {item.STATUS === 'PENDING' && <li className="list-inline-item px-2">
                                                    <Link
                                                        to={{
                                                            pathname: constant.Authedcomponent.leaveEdit.url,
                                                            state: {
                                                                data: btoa(JSON.stringify(item)),
                                                                page: page,
                                                            },
                                                        }}
                                                        title="Edit"
                                                    >
                                                        <i className="bx bx-edit text-primary"></i>
                                                    </Link>
                                                </li>}


                                            </ul>
                                        </td>
                                    </tr>
                                    {/* Modal */}
                                    <div
                                        className="modal fade"
                                        id={`leaveModal-${item.ID}`}
                                        data-bs-backdrop="static"
                                        data-bs-keyboard="false"
                                        tabIndex={-1}
                                        role="dialog"
                                        aria-labelledby="leaveModalLabel"
                                        aria-hidden="true"
                                    >
                                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="leaveModalLabel">
                                                        Leave Application Details
                                                    </h5>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                    />
                                                </div>
                                                <div className="modal-body">
                                                    <table className="table table-striped mb-3">
                                                        <tbody>
                                                            <tr>
                                                                <td>Employee Name</td>
                                                                <td>{item.EMPLOYEE_NAME || item.FULL_NAME}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Location</td>
                                                                <td>{item.LOCATION_NAME}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Leave Duration</td>
                                                                <td>{item.LEAVE_FROM} to {item.LEAVE_TO} ({item.TOTAL_DAYS} days)</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Reason</td>
                                                                <td>{item.NOTE || 'No reason provided'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Remarks</td>
                                                                <td>{item.REMARKS || 'No remarks'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Status</td>
                                                                <td>
                                                                    <span style={{
                                                                        color: item.STATUS === 'APPROVED' ? 'green' :
                                                                            item.STATUS === 'REJECTED' ? 'red' :
                                                                                item.STATUS === 'PENDING' ? '#ffc107' :
                                                                                    '#6c757d',
                                                                        fontWeight: 500
                                                                    }}>
                                                                        {item.STATUS}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>


                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>

                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center text-muted">No leave applications found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                range={5}
                limit={limit}
                totalCount={total}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default AppliedLeaveList;
